import { BreezeEntityTypeSourceDirective } from './breeze-entity-type-source.directive';
import { BreezeFormErrorComponent } from './breeze-form-error.component';
import { BreezeFormErrorDirective } from './breeze-form-error.directive';
import { BreezeKeyedValidationFilterPipe } from './breeze-keyed-validation-filter.pipe';
import { BreezeModelPropertyValidatorDirective } from './breeze-model-property-validator.directive';
import { BreezeModelSourceDirective } from './breeze-model-source.directive';
import { BreezePropertyOptionsDirective } from './breeze-property-options.directive';
import { BreezePropertyRequiredDirective } from './breeze-property-required.directive';
import { BreezePropertyValidatorDirective } from './breeze-property-validator.directive';
import { BreezePropertyDirective } from './breeze-property.directive';
import { BreezeValidationMessagePipe } from './breeze-validation-message.pipe';
export * from './form-error-base.component';

/**
 * Utility array that contains validation message pipes
 */
export const BREEZE_ENTITY_UI_VALIDATION = [BreezeValidationMessagePipe, BreezeKeyedValidationFilterPipe] as const;

/**
 * Utility array that contains breeze model binding directives
 */
export const BREEZE_ENTITY_UI_FORM = [
  BreezeFormErrorDirective,
  BreezeModelSourceDirective,
  BreezePropertyRequiredDirective,
  BreezePropertyValidatorDirective,
  BreezePropertyDirective,
  BreezeModelPropertyValidatorDirective,
  BreezeEntityTypeSourceDirective,
  BreezePropertyOptionsDirective
] as const;

/**
 * Utility array that contains all `@mri-platform/breeze-entity` related components and directives
 */
export const BREEZE_ENTITY_UI = [...BREEZE_ENTITY_UI_VALIDATION, ...BREEZE_ENTITY_UI_FORM] as const;

export {
  BreezeFormErrorComponent,
  BreezeValidationMessagePipe,
  BreezeFormErrorDirective,
  BreezeKeyedValidationFilterPipe,
  BreezeModelPropertyValidatorDirective,
  BreezeModelSourceDirective,
  BreezePropertyOptionsDirective,
  BreezePropertyRequiredDirective,
  BreezePropertyValidatorDirective,
  BreezePropertyDirective,
  BreezeEntityTypeSourceDirective
};
